export default __webpack_public_path__ + "static/media/not-supported.6fcd440f.svg";